var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import Money from './Money';
import { api } from '../../helpers/Api';
export default class MoneysStore {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.read = () => {
            return api.get(`moneys`).then(this.set);
        };
        this.set = (data) => {
            console.log('MoneysStore - data: ', data);
            this.loaded = true;
            this.data = data.map(value => new Money(value));
            return this.data;
        };
        /*getWebMoney = () => {
          return (this.data.find(money => money.web) || this.data.find((money: Money) => money.alphabeticCode === 'EUR'))
        }*/
    }
    setData(data) {
        console.log('data: ', data);
        this.set(data);
    }
}
__decorate([
    observable
], MoneysStore.prototype, "data", void 0);
__decorate([
    observable
], MoneysStore.prototype, "loaded", void 0);
__decorate([
    action
], MoneysStore.prototype, "set", void 0);
__decorate([
    action
], MoneysStore.prototype, "setData", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Moneys/MoneysStore.ts
// module id = 567
// module chunks = 0